<template>
  <component
    :is="touch"
    :isEdit='isEdit'
    :editId='editId'
    :letDelete='letDelete'
    :preloadedItem='preloadedItem'
    @delete='()=>{$emit("delete")}'
    @exit='arg=>{$emit("exit", arg)}'
    @newInput="newVal => { $emit('newInput', newVal) }"/>
</template>

<script>
import { indexBaseMixin } from '@/components/customFields/commonMixins/_helpers/indexBase.mixin'
import writingView from './writingView'
import addingPreview from './addingPreview'
import settingView from './settingView'

export default {
  mixins: [indexBaseMixin],
  name: 'RoundNumber',
  components: {
    writingView,
    addingPreview,
    settingView
  }
}
</script>
